<ng-container *transloco="let t">
    <app-admin-modal-layout
            [title]="title ?? ''"
            (onSave)="onSaveButtonClick()"
            (onClose)="onClose()"
    >
        <div class="pb-4">
            <form [formGroup]="inputForm">
                <div class="row">
                    <div class="col-12 pb-3">
                        <app-language-input [inputForm]="inputForm"
                                            [defaultLanguage]="league?.defaultLanguage"
                                            [extraLanguages]="league?.extraLanguages"
                                            [hrKey]="'name'"
                                            [enKey]="'nameEng'"
                                            [srKey]="'nameSr'"
                                            [bsKey]="'nameBs'"
                                            [itKey]="'nameIta'" [siKey]="'nameSlo'" [hrLabel]="'event.item.nameCro'"
                                            [enLabel]="'event.item.nameEn'" [bsLabel]="'event.item.nameBs'" [srLabel]="'event.item.nameSr'" [itLabel]="'event.item.nameIt'"
                                            [siLabel]="'event.item.nameSlo'"/>
                    </div>
                </div>
              <div class="row">
                <div class="col-12 pb-3">
                  <app-language-input [inputForm]="inputForm.controls.nameShort"
                                      [defaultLanguage]="league?.defaultLanguage"
                                      [extraLanguages]="league?.extraLanguages"
                                      [hrKey]="'hr'"
                                      [enKey]="'en'"
                                      [srKey]="'sr'"
                                      [bsKey]="'bs'"
                                      [itKey]="'it'"
                                      [siKey]="'si'"
                                      [hrLabel]="'event.item.nameCro.short'" [enLabel]="'event.item.nameEn.short'"
                                      [bsLabel]="'event.item.nameBs.short'" [srLabel]="'event.item.nameSr.short'" [itLabel]="'event.item.nameIt.short'"
                                      [siLabel]="'event.item.nameSlo.short'"
                                      [required]="false"/>
                </div>
              </div>
                <div class="row">
                    <div class="col-xl-6 col-12 pb-3">
                        <app-input formControlName="city" label="event.item.city" cssClass="pb-3"/>
                    </div>
                    <div class="col-xl-6 col-12 pb-3">
                        <app-select formControlName="country" [items]="countries"
                                    labelKey="id" labelKeyPrefix="app.common.country."
                                    [valueKey]="'id'" [hasDefault]="true"
                                    label="event.item.country"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-6 col-12 pb-3">
                        <app-date-time-input formControlName="start" [displayTime]="true"
                                             [label]="t('event.item.start.date')"
                                             [maxDate]="inputForm.controls['end'].value">
                        </app-date-time-input>
                    </div>
                    <div class="col-xl-6 col-12 pb-3">
                        <app-date-time-input formControlName="end" [displayTime]="true"
                                             [label]="t('event.item.end.date')"
                                             [minDate]="inputForm.controls['start'].value">
                        </app-date-time-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-6 col-12 pb-3">
                        <app-select formControlName="leagueTemplateStatus" [items]="leagueTemplateStatuses"
                                    labelKeyPrefix="league.template.event.status."
                                    label="league.template.event.status"/>
                    </div>
                    <div class="col-xl-6 col-12 pb-3">
                        <app-select formControlName="sportOne" [items]="sports"
                                    [valueKey]="'id'" [labelKey]="'id'" [labelKeyPrefix]="'app.common.sports.'"
                                    label="app.common.sport"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 pb-4">
                        <app-tags-input [inputLabel]="t('league.template.event.lengths')"
                                        [tags]="inputForm.controls['lengths'].value"
                                        [isRequired]="inputForm.controls['lengths'].errors?.['required']"
                                        [showErrorMessage]="inputForm.controls['lengths'].touched"
                                        (onTagRemoved)="removeTagAtIndex($event)" (tagsChanged)="lengthsChanged($event)"
                                        [errors]="inputForm.controls['lengths'].errors"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-xl-6 pb-3">
                            <app-drag-and-drop [selectedFile]="inputForm.value.image" (fileChange)="imageChanged($event)"
                                               [useWithCropper]="true" [cropAreaWidth]="325" [cropAreaHeight]="190"
                                               [cropperModalSize]="'xl'"
                                               ></app-drag-and-drop>
                    </div>
                    <div class="col-12 col-xl-6 pb-3">
                        <app-drag-and-drop [selectedFile]="inputForm.value.imageIcon" (fileChange)="logoChanged($event)"
                                           [useWithCropper]="true" [cropAreaWidth]="240" [cropAreaHeight]="240"
                                           [cropperModalSize]="'xl'"
                        ></app-drag-and-drop>
                    </div>

                </div>
            </form>
        </div>

    </app-admin-modal-layout>
</ng-container>
